var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2200,
    height: 44,
    viewBox: "0 0 2200 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.531 7.51241C-22.8506 -1.15699 -120.636 28.0207 -146.856 43.6932H2518.34V16.2517C2499.22 16.7178 2461.4 23.1546 2400.82 29.0111C2316.6 37.1525 1928.85 24.9911 1684.54 7.51241C1440.23 -9.96623 1038.6 7.51241 686.944 24.9911C335.286 42.4697 385.258 18.3492 158.531 7.51241Z",
    fill: "#E8FFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorLine);
export default __webpack_public_path__ + "static/media/vectorLine.848267cb.svg";
export { ForwardRef as ReactComponent };